import axios from 'axios';
import URLS from '../../util/urls.js';
import funcoes from '../../util/funcoes.js';

const state = {
  listaContasPagar: [],
  contaPagarPesquisa: {
    pagina: 0,
    contaPlanoConta: {
      grupoPlanoConta: {
       tipo: 'DESPESA' 
      }
    },
    fornecedor: {},
    vencimentoInicio: funcoes.primeiroDiaMes(), 
    vencimentoFim: funcoes.ultimoDiaMes()
  },
  labelQuantidade: '',
  contaPagarSelecionado: {
    id: 0,
    status: 'PROVISORIA',
    contaBancaria: { nome: '' },
    periodicidade: 30,
    quantidadeParcelas: 2
  },
  lancamentoSelecionado: {
    id: 0,
    conta: { id: 0 },
    contaBancaria: { id: 0 },
    status: 'ABERTO',
    dataPagamento: funcoes.hoje(),
  },
  planosDisponiveis: [],
  clientesDisponiveis: [],
  fornecedoresDisponiveis: [],
  logs: [],
}

const mutations = {
  atualizarListaContasPagar(state, payload) {
    if(state.contaPagarPesquisa.pagina === 0) {
      state.listaContasPagar = payload.lista;
    } else {
      state.listaContasPagar.push(...payload.lista);
    }

    state.labelQuantidade = payload.lista.length + (payload.lista.length == 1 ? " conta encontrada" : " contas encontradas");
  },
  limparContasPagarListadas(state) {
    state.listaContasPagar = [];
  },
  limparContaPagarPesquisa(state) {
    state.contaPagarPesquisa = {
      pagina: 0,
      contaPlanoConta: {
        grupoPlanoConta: {
         tipo: 'DESPESA' 
        }
      },
      fornecedor: {},
      vencimentoInicio: funcoes.primeiroDiaMes(),
      vencimentoFim: funcoes.ultimoDiaMes()
    };
  },
  atualizarContaPagarSelecionado(state, payload) {
    state.contaPagarSelecionado = payload;
    state.planosDisponiveis = payload.contaPlanoConta ? [payload.contaPlanoConta] : [];
    state.clientesDisponiveis = payload.cliente ? [payload.cliente] : [];
    state.fornecedoresDisponiveis = payload.fornecedor ? [payload.fornecedor] : [];
  },
  novoContaPagar(state) {
    state.contaPagarSelecionado = {
      id: 0,
      status: 'PROVISORIA',
      contaBancaria: { nome: '' },
      periodicidade: 30
    }
    state.lancamentoSelecionado = {
      id: 0,
      conta: { id: 0 },
      contaBancaria: { id: 0 },
      status: 'ABERTO'
    }

    state.logs = [];
  },
  novoLancamento(state) {
    state.lancamentoSelecionado = {
      id: 0,
      conta: { id: 0 },
      contaBancaria: { id: 0 },
      status: 'ABERTO'
    }
  },
  atualizarLancamentoSelecionado(state, payload) {
    state.lancamentoSelecionado = {
      ...payload,
      dataPagamento: funcoes.hoje()
    };
  },
  atualizarPlanosDisponiveis(state, payload) {
    state.planosDisponiveis = payload;
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload;
  },
  atualizarFornecedoresDisponiveis(state, payload) {
    state.fornecedoresDisponiveis = payload;
  },

  atualizarLogs(state, logs) {
    state.logs = logs;
  },

  limparLogs(state) {
    state.logs = [];
  },
}

const actions = {
  listarContasPagar(context, payload) {
    return axios.post(URLS.CONTAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaContasPagar', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarContasPagar', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparContasPagarListadas(context) {
    context.commit('limparContasPagarListadas');
  },
  limparContaPagarPesquisa(context){
    context.commit('limparContaPagarPesquisa');
  },
  recuperarContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaPagarSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarContaPagar', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoContaPagar(context) {
    context.commit('novoContaPagar');
  },
  gravarContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  aprovarContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_APROVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('aprovarContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  desaprovarContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_DESAPROVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('desaprovarContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  cancelarContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_CANCELAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "ERRO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('cancelarContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  removerContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoContaPagar');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  listarPlanos(context, payload) {
    return axios.post(URLS.PLANO_CONTA_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlanosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarPlanos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarPlanosDisponiveis', []);
          return response.data;
      }
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarFornecedores(context, payload) {
    return axios.post(URLS.FORNECEDORES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFornecedoresDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarFornecedores', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  // LANCAMENTOS
  novoLancamento(context,payload){
    context.commit('novoLancamento',payload);
  },
  atualizarLancamentoSelecionado(context,payload){
    context.commit('atualizarLancamentoSelecionado',payload);
  },
  gravarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
          case "FALHA":
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarLancamento', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  recuperarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLancamentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerLancamentoConta(context, payload) {
    return axios.post(URLS.LANCAMENTOS_REMOVER, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaPagarSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('removerLancamentoConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  pagarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_PAGAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('recuperarContaPagar', payload.conta);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('pagarLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  fecharContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_FECHAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "ERRO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('fecharContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },

  reabrirContaPagar(context, payload) {
    return axios.post(URLS.CONTAS_REABRIR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "ERRO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('reabrirContaPagar', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            context.commit('atualizarContaPagarSelecionado', response.data.item);
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },

  cancelarPagamentoLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_CANCELAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaPagarSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('cancelarPagamentoLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  devolverCheque(context, payload) {
    return axios.post(URLS.LANCAMENTOS_DEVOLVER_CHEQUE, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaPagarSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('devolverCheque', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarRecibo(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("gerarRecibo", payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarLogs(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarLogs', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
}

export default {
  state,
  mutations,
  actions
}